<template>
    <div>
        <EditPaymentMethodModal @reload="indexPaymentmethods()" :paymentMethod="paymentMethod" v-model:open="paymentMethodEditModalOpen" />
        <RemovePaymentMethodModal @reload="indexPaymentmethods()" :paymentMethod="paymentMethod" v-model:open="paymentMethodRemoveModalOpen" />
        <AddPaymentMethodModal
            v-if="showConfirmModal"
            :open="showConfirmModal"
            :title="$t('add_payment_method')"
            :message="$t('created_payment_method_applied_to_all_warning')"
            :paymentMethod="newPaymentMethods.find((method) => method.id === selectedNewPaymentMethod)?.name"
            @update:open="showConfirmModal = $event"
            @confirm="addPaymentMethod"
            @cancel="showConfirmModal = false"
        />

        <div class="w-full flex flex-col lg:flex-row lg:justify-between py-4 border-b border-gray-300">
            {{ $t('existing_payment_methods') }}
        </div>

        <div class="my-8">
            <Loading :loading="loading" :preserveHeight="true">
                <div v-if="get?.data?.length">
                    <div>
                        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                            <SinglePaymentMethod
                                v-for="paymentMethod in get.data"
                                :key="paymentMethod.id"
                                :showToggle="false"
                                :paymentMethod="paymentMethod"
                                class="flex flex-row w-full rounded-md shadow-md border border-white"
                                @click="openEdit(paymentMethod)"
                            >
                                <template v-slot:options>
                                    <Icon @click.stop="openRemove(paymentMethod)" v-if="paymentMethod.deleteable" type="Delete" width="18" height="21" viewBox="0 0 15 18" />
                                </template>
                            </SinglePaymentMethod>
                        </div>
                    </div>
                </div>
                <div v-else>
                    {{ $t('no_payment_method_create_during_checkout') }}
                </div>
            </Loading>
        </div>

        <div class="w-full flex flex-col lg:flex-row lg:justify-between py-4 border-b border-gray-300">
            {{ $t('add_payment_method') }}
        </div>

        <div class="my-8">
            <div class="grid grid-cols-1 gap-4">
                <NewPaymentMethod
                    v-for="newPaymentMethod in newPaymentMethods"
                    :isOverview="false"
                    :key="newPaymentMethod.id"
                    :paymentMethod="newPaymentMethod"
                    v-model:selectedNewPaymentMethod="selectedNewPaymentMethod"
                />
            </div>

            <form action="/profile/paymentmethods" method="POST" ref="newPaymentMethodForm">
                <input type="hidden" name="payment_method" :value="selectedNewPaymentMethod" />
                <input type="hidden" name="_token" :value="csrf" />
            </form>

            <div class="flex justify-end">
                <FormButton
                    type="button"
                    @click="confirmAddPaymentMethod"
                    class="mt-6 w-auto"
                    styling="primary"
                    :value="$t('add_payment_method')"
                    :disabled="!selectedNewPaymentMethod"
                >
                </FormButton>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddPaymentMethodModal from './AddPaymentMethodModal.vue';
import i18next from 'i18next';

export default {
    components: {
        AddPaymentMethodModal
    },
    mounted() {
        this.csrf = window.meta.csrf;
        this.loading = true;

        // check if direct debit is enabled or filter it out
        this.directDebitEnabled = window.meta.direct_debit_enabled;
        if (!this.directDebitEnabled) {
            this.newPaymentMethods = this.newPaymentMethods.filter((method) => method.id !== 'DIRECTDEBIT');
        }

        const currentDomain = window.location.hostname;
        // if (currentDomain.includes('hkcmglobal')) {
        //     this.newPaymentMethods = this.newPaymentMethods.filter(method => method.id !== 'PAYPAL');
        // }

        this.indexPaymentmethods().then(() => {
            this.loading = false;
        });
    },

    methods: {
        paginate(page = 1) {
            this.loading = true;
            this.indexPaymentmethods({
                page: page
            }).then(() => {
                this.loading = false;
            });
        },
        async indexPaymentmethods(params) {
            let config = {
                params: {
                    'sort[by]': 'created_at'
                }
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('payment_methods/index', config);
        },
        confirmAddPaymentMethod() {
            this.showConfirmModal = true;
        },
        addPaymentMethod() {
            this.showConfirmModal = false;
            this.$refs.newPaymentMethodForm.submit();
        },
        openEdit(paymentMethod) {
            this.paymentMethodEditModalOpen = true;
            this.paymentMethod = paymentMethod;
        },
        openRemove(paymentMethod) {
            this.paymentMethodRemoveModalOpen = true;
            this.paymentMethod = paymentMethod;
        }
    },

    data: () => ({
        selectedItems: [],
        isAllSelected: false,
        daterange: null,
        component: null,
        popupOpen: false,
        loading: false,
        selectedPaymentMethod: null,
        newPaymentMethods: [
            {
                name: i18next.t('payment_creditcard'),
                id: 'CREDITCARD'
            },
            {
                name: 'PayPal',
                id: 'PAYPAL'
            }
        ],
        selectedNewPaymentMethod: null,
        csrf: null,
        paymentMethod: null,
        paymentMethodEditModalOpen: false,
        paymentMethodRemoveModalOpen: false,
        showConfirmModal: false
    }),

    computed: {
        ...mapGetters('payment_methods', ['get'])
    },

    watch: {
        daterange() {
            this.loading = true;
            this.$store
                .dispatch('invoices/index', {
                    params: {
                        invoiced_at: this.daterange
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
